import React from 'react';
import { useLoading } from '../../context/LoadingContext';
import LoadingSpinner from './LoadingSpinner';
import { useLocation } from 'react-router-dom';

const GlobalLoadingOverlay: React.FC = () => {
  const { isLoading, loadingText, loadingSubtitle } = useLoading();
  const location = useLocation();

  // Auth sayfalarında loading overlay'i gösterme
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';

  if (!isLoading || isAuthPage) {
    return null;
  }

  return (
    <div className="global-loading-overlay">
      <LoadingSpinner 
        size={80}
        text={loadingText}
        subtitle={loadingSubtitle}
        fullHeight={true}
        className="global-loading-spinner"
      />
    </div>
  );
};

export default GlobalLoadingOverlay;
